import { type PaymentMethod } from "./types";
import { type ServerPaymentMethod } from "@/shared/api/payment/api-payment";
import { paymentMethodsConfig } from "./payment-methods.config.ts";
import { CardIcon } from "../../assets/icons/CardIcon.tsx";

const findConfig = (serverTitle: string) => {
  const lowerTitle = serverTitle.toLowerCase();
  return paymentMethodsConfig.find((config) =>
    config.keywords.some((keyword) => lowerTitle.includes(keyword)),
  );
};

export const mapServerMethodToPaymentMethod = (
  serverMethod: ServerPaymentMethod,
): PaymentMethod => {
  const config = findConfig(serverMethod.title);

  return {
    name: config ? config.displayName : serverMethod.title,
    method: serverMethod.payment_id,
    logo: config ? config.logo : CardIcon,
  };
};
